import * as amplitude from '@amplitude/unified';
import { Identify } from '@amplitude/unified';

const AMPLITUDE_API_KEY = import.meta.env.VITE_AMPLITUDE_API_KEY;

let initPromise: Promise<void> | null = null;
let isInitialized = false;

export const initAmplitude = async () => {
  if (initPromise) return initPromise;
  
  if (!AMPLITUDE_API_KEY) {
    console.warn('[Amplitude] API Key missing. Tracking disabled.');
    return;
  }

  initPromise = amplitude.initAll(AMPLITUDE_API_KEY, {
    analytics: {
      autocapture: {
        attribution: true,
        fileDownloads: true,
        formInteractions: true,
        pageViews: true,
        sessions: true,
        elementInteractions: true,
      },
    },
    sessionReplay: {
      sampleRate: 0,
    }
  }).then(() => {
    isInitialized = true;
    console.log('[Amplitude] Initialized');
  }).catch(err => {
    console.error('[Amplitude] Initialization error:', err);
  });

  return initPromise;
};

const ensureInitialized = async () => {
  if (!isInitialized && initPromise) {
    await initPromise;
  }
  return isInitialized;
};

export const trackEvent = async (eventName: string, eventProperties?: Record<string, any>) => {
  if (!(await ensureInitialized())) return;
  try {
    amplitude.track(eventName, eventProperties);
  } catch (error) {
    console.error('[Amplitude] Track error:', error);
  }
};

export const identifyUser = async (userId: string, userProperties?: Record<string, any>) => {
  if (!(await ensureInitialized())) return;
  try {
    amplitude.setUserId(userId);
    if (userProperties) {
      const identifyObj = new Identify();
      Object.entries(userProperties).forEach(([key, value]) => {
        if (value !== undefined && value !== null) {
          identifyObj.set(key, value);
        }
      });
      amplitude.identify(identifyObj);
    }
    console.log('[Amplitude] User identified:', userId);
  } catch (error) {
    console.error('[Amplitude] Identify error:', error);
  }
};

export const resetUser = async () => {
  if (!(await ensureInitialized())) return;
  try {
    amplitude.reset();
    console.log('[Amplitude] User reset');
  } catch (error) {
    console.error('[Amplitude] Reset error:', error);
  }
};
